<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 258.75 332.71" id="gamelogo">
        <defs></defs>
        <title>TunnelVue</title>
        <g id="Laag_2" data-name="Laag 2">
            <g id="Laag_1-2" data-name="Laag 1">
                <polygon class="cls-1" points="129.39 126.73 204.03 221.6 202 223.17 129.37 126.75 129.39 126.73" />
                <circle class="cls-1" cx="129.38" cy="126.74" r="0.08" />
                <polygon class="cls-1" points="129.38 126.76 63.38 227.83 61.24 226.4 129.36 126.74 129.38 126.76" />
                <polygon class="cls-1" points="129.35 126.75 12.83 95.24 13.52 92.77 129.36 126.72 129.35 126.75" />
                <polygon class="cls-1" points="129.37 126.75 127.22 6.05 129.79 6.03 129.4 126.75 129.37 126.75" />
                <polygon class="cls-2" points="129.34 126.63 240.69 78.67 248.28 102.09 129.43 126.88 129.34 126.63" />
                <polygon class="cls-2" points="129.48 126.72 212.13 215.41 192.64 230.44 129.27 126.88 129.48 126.72" />
                <polygon class="cls-2" points="129.53 126.81 71.92 233.48 51.45 219.82 129.31 126.66 129.53 126.81" />
                <polygon class="cls-2" points="129.35 126.88 10.04 105.37 16.65 81.66 129.42 126.63 129.35 126.88" />
                <polygon class="cls-2" points="129.22 126.77 117.94 6.06 142.56 6.06 129.49 126.77 129.22 126.77" />
                <circle class="cls-3" cx="129.38" cy="126.74" r="120.24" />
                <circle class="cls-4" cx="129.38" cy="126.74" r="65.66" />
                <path class="cls-5" d="M149.41,71.92l-20,36.14-20-36.14H42.61l86.77,156.49L216.14,71.92Z" />
                <path class="cls-6" d="M149.41,71.92l-20,36.14-20-36.14h-32l52.06,93.89,52.05-93.89Z" />
                <rect class="cls-2" y="324.21" width="258.75" height="8.5" />
                <path class="cls-1" d="M7.92,278.81v-8.65h24.5v8.65h-8v48.61H15.93V278.81Z" />
                <path
                    class="cls-1"
                    d="M58.26,270.16v45.5a15.39,15.39,0,0,1-1.42,6.23,10.67,10.67,0,0,1-3.37,4.21A10.12,10.12,0,0,1,47,328.05a10.36,10.36,0,0,1-6.6-1.95,10.56,10.56,0,0,1-3.3-4.21,15.55,15.55,0,0,1-1.41-6.23v-45.5h8.48v45.5a4.89,4.89,0,0,0,1.18,3.58,2.25,2.25,0,0,0,1.65.63,2.47,2.47,0,0,0,2.51-2.11,5.27,5.27,0,0,0,.32-2.1v-45.5Z"
                />
                <path
                    class="cls-1"
                    d="M73.42,297.59l-.71-2.65h-.47v32.48H64.46V270.16H72L80.25,300l.71,2.65h.47V270.16H89.2v57.26H81.66Z"
                />
                <path
                    class="cls-1"
                    d="M104.44,297.59l-.71-2.65h-.47v32.48H95.49V270.16H103L111.27,300l.71,2.65h.47V270.16h7.78v57.26h-7.54Z"
                />
                <path class="cls-1" d="M126.51,270.16h19.4v8.65H135v15h7.86V303H135v15.74h10.92v8.64h-19.4Z" />
                <path class="cls-1" d="M150.62,270.16h8.48v49.47h11.23v7.79H150.62Z" />
                <path
                    class="cls-1"
                    d="M189.18,270.16h8.25l-8.8,57.26h-8.48l-8.8-57.26h8.25l4.24,31.48.32,2.41h.47l.31-2.41Z"
                />
                <path
                    class="cls-1"
                    d="M223.82,270.16v45.5a15.39,15.39,0,0,1-1.42,6.23A10.67,10.67,0,0,1,219,326.1a10.12,10.12,0,0,1-6.52,1.95,10.36,10.36,0,0,1-6.6-1.95,10.56,10.56,0,0,1-3.3-4.21,15.55,15.55,0,0,1-1.41-6.23v-45.5h8.48v45.5a4.89,4.89,0,0,0,1.18,3.58,2.25,2.25,0,0,0,1.65.63,2.47,2.47,0,0,0,2.51-2.11,5.27,5.27,0,0,0,.32-2.1v-45.5Z"
                />
                <path class="cls-1" d="M230,270.16h19.4v8.65H238.51v15h7.85V303h-7.85v15.74h10.91v8.64H230Z" />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'GameLogoComponent'
};
</script>
